/* eslint-disable no-console */
import { hasAssets } from './account-api';

const showNavIndicator = (status) => {
  const icon = document.querySelector('.main-nav .icon-item-my-account');
  const visibleClass = 'items-added-to-account';

  if (!status) {
    icon.classList.remove(visibleClass);
  } else {
    icon.classList.add(visibleClass);
  }
};

const updateAccountStatusMessage = (assetType, action) => {
  const msgDiv = document.querySelector('.main-nav .my-account-status-message');
  if (!window.isAuthenticated || !msgDiv) {
    return;
  }
  // Clear existing message
  msgDiv.innerHTML = '';
  setTimeout(() => {
    if (action === 'add') {
      msgDiv.innerHTML = `${assetType} has been added to your favorites.`;
    }
    if (action === 'remove') {
      msgDiv.innerHTML = `${assetType} has been removed from your favorites.`;
    }
  }, 100);
};

const updateAccountIconStatus = () => {
  if (!window.isAuthenticated) {
    return;
  }
  hasAssets((data) => {
    if (data['has-assets']) {
      showNavIndicator(true);
    } else {
      showNavIndicator(false);
    }
  });
};

export {
  updateAccountIconStatus,
  updateAccountStatusMessage,
};
/* eslint-enable no-console */
